(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-bxc-grid]');
    const more = root.querySelector('[data-bxc-more]');
    const progress = root.querySelector('[data-bxc-progress]');
    const error = root.querySelector('[data-bxc-load-error]');
    const dialog = root.querySelector('dialog');
    const trigger = root.querySelector('[data-bxc-open]');
    const stockFirst = root.dataset.stockFirst === 'true';
    const persist = root.dataset.persist !== 'false';
    const batch = Number(root.dataset.batch) || 24;
    let desired = batch;
    let next = grid?.dataset.next || '';
    let pages = 1;
    let pending = null;
    let oldOverflow = '';
    const cards = () => Array.from(grid?.querySelectorAll('[data-bxc-card]') || []);
    const key = `boxzy-collection:${location.pathname}${location.search}`;
    const save = () => {
      if (!persist) return;
      try { sessionStorage.setItem(key, JSON.stringify({ shown: desired, pages, scroll: scrollY, time: Date.now() })); } catch (_) {}
    };
    const update = () => {
      let list = cards();
      if (stockFirst) {
        list = [...list.filter(card => card.dataset.available === 'true'), ...list.filter(card => card.dataset.available !== 'true')];
        list.forEach(card => grid.append(card));
      }
      let shown = 0;
      list.forEach(card => {
        const waiting = stockFirst && next && card.dataset.available !== 'true';
        card.hidden = shown >= desired || Boolean(waiting);
        if (!card.hidden) shown += 1;
      });
      if (progress) progress.textContent = root.dataset.loadedLabel.replace('__COUNT__', String(shown)).replace('__TOTAL__', grid.dataset.total);
      if (more) more.hidden = !next && shown >= list.length;
    };
    const loadPage = async () => {
      if (!next) return;
      const url = new URL(next, location.href);
      if (url.origin !== location.origin) throw new Error('Invalid collection URL');
      url.searchParams.set('section_id', root.dataset.section);
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Collection unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incoming = page.querySelector('[data-bxc-grid]');
      if (!incoming) throw new Error('Collection unavailable');
      const seen = new Set(cards().map(card => card.dataset.productId));
      incoming.querySelectorAll('[data-bxc-card]').forEach(card => {
        if (seen.has(card.dataset.productId)) return;
        const imported = document.importNode(card, true);
        imported.hidden = true;
        grid.append(imported);
        seen.add(card.dataset.productId);
      });
      const following = incoming.dataset.next || '';
      if (following === next) throw new Error('Collection did not advance');
      next = following;
      pages += 1;
    };
    const fill = async (restorePages = 1) => {
      if (pending) return pending;
      pending = (async () => {
        await Promise.resolve();
        if (more) { more.disabled = true; more.setAttribute('aria-busy', 'true'); more.textContent = root.dataset.loadingLabel; }
        if (error) error.textContent = '';
        try {
          while (next && (pages < restorePages || (stockFirst ? cards().filter(card => card.dataset.available === 'true').length : cards().length) < desired)) await loadPage();
        } catch (_) { if (error) error.textContent = root.dataset.errorLabel; }
        finally {
          update();
          if (more) { more.disabled = false; more.removeAttribute('aria-busy'); more.textContent = root.dataset.moreLabel; }
          pending = null;
        }
      })();
      return pending;
    };
    if (grid) {
      update();
      let restored = null;
      try {
        if (persist && performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
          const state = JSON.parse(sessionStorage.getItem(key) || 'null');
          if (state && Date.now() - state.time < 1800000) restored = state;
        }
      } catch (_) {}
      if (restored) {
        desired = Math.max(batch, Math.min(Number(restored.shown) || batch, Number(grid.dataset.total)));
        fill(Math.min(Number(restored.pages) || 1, 20)).then(() => window.scrollTo({ top: Number(restored.scroll) || 0, behavior: 'instant' }));
      } else fill();
      more?.addEventListener('click', async () => {
        if (pending) return;
        const before = cards().filter(card => !card.hidden).length;
        desired += batch;
        await fill();
        const revealed = cards().filter(card => !card.hidden);
        if (revealed.length > before) revealed[before].querySelector('a')?.focus({ preventScroll: true });
        save();
      });
      root.addEventListener('click', event => { if (event.target.closest('.bxc-card a')) save(); }, true);
      if (persist) window.addEventListener('pagehide', save);
    }
    if (dialog && trigger) {
      trigger.addEventListener('click', () => {
        oldOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        trigger.setAttribute('aria-expanded', 'true');
      });
      dialog.querySelector('[data-bxc-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.body.style.overflow = oldOverflow;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({ preventScroll: true });
      });
    }
    root.querySelectorAll('[data-bxc-option-search]').forEach(input => input.addEventListener('input', () => {
      const term = input.value.toLocaleLowerCase().trim();
      input.closest('details').querySelectorAll('[data-bxc-value]').forEach(row => { row.hidden = !row.innerText.toLocaleLowerCase().includes(term); });
    }));
    root.querySelectorAll('[data-bxc-price]').forEach(price => {
      const min = price.querySelector('[data-bxc-min]'), max = price.querySelector('[data-bxc-max]');
      const low = price.querySelector('[data-bxc-low]'), high = price.querySelector('[data-bxc-high]');
      const validate = () => {
        const lower = Number(min.value || 0), upper = max.value === '' ? Number(max.max) : Number(max.value);
        min.setCustomValidity(lower > upper ? price.querySelector('[data-bxc-range-error]').textContent : '');
        low.value = String(lower); high.value = String(upper);
      };
      min.addEventListener('input', validate); max.addEventListener('input', validate);
      low.addEventListener('input', () => { low.value = String(Math.min(Number(low.value), Number(high.value))); min.value = low.value; validate(); });
      high.addEventListener('input', () => { high.value = String(Math.max(Number(high.value), Number(low.value))); max.value = high.value; validate(); });
    });
    root.querySelectorAll('.bxc-filters-form,.bxc-sort-form').forEach(form => form.addEventListener('submit', event => {
      if (!form.checkValidity()) return;
      event.preventDefault();
      const url = new URL(form.action, location.href);
      for (const [name, value] of new FormData(form)) if (String(value).trim() !== '') url.searchParams.append(name, value);
      for (const name of ['preview_theme_id', 'pb']) if (new URL(location.href).searchParams.has(name)) url.searchParams.set(name, new URL(location.href).searchParams.get(name));
      location.assign(url.href);
    }));
    root.querySelector('[data-bxc-sort]')?.addEventListener('change', event => event.target.form.requestSubmit());
    root.addEventListener('submit', async event => {
      const form = event.target.closest('.bxc-add-form');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('[data-bxc-add]');
      if (button.disabled) return;
      const label = button.textContent, message = form.querySelector('.bxc-error');
      button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = button.dataset.adding; message.textContent = '';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || button.dataset.error);
        save(); location.assign(button.dataset.cartUrl);
      } catch (failure) {
        message.textContent = failure.message || button.dataset.error;
        button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = label;
      }
    });
  };
  const start = () => document.querySelectorAll('[data-bxc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
